import Cookies from 'js-cookie'

// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) =>
  Cookies.set(sidebarStatusKey, sidebarStatus)

const languageKey = 'language'
export const getLanguage = () => localStorage.getItem(languageKey)
export const setLanguage = (language: string) => localStorage.setItem(languageKey, language)

const sizeKey = 'size'
export const getSize = () => Cookies.get(sizeKey)
export const setSize = (size: string) => Cookies.set(sizeKey, size)

// User
const tokenKey = 'vue_typescript_admin_access_token'
// export const getToken = () => Cookies.get(tokenKey)
// export const setToken = (token: string) => Cookies.set(tokenKey, token)
// export const removeToken = () => Cookies.remove(tokenKey)
export const getToken = () => localStorage.getItem(tokenKey)
export const setToken = (token: string) => localStorage.setItem(tokenKey, token)
export const removeToken = () => localStorage.removeItem(tokenKey)

const antTokenKey = 'ant_typescript_admin_access_token'
// export const getToken = () => Cookies.get(tokenKey)
// export const setToken = (token: string) => Cookies.set(tokenKey, token)
// export const removeToken = () => Cookies.remove(tokenKey)
export const getAntToken = () => localStorage.getItem(antTokenKey)
export const setAntToken = (token: string) => localStorage.setItem(antTokenKey, token)
export const removeAntToken = () => localStorage.removeItem(antTokenKey)

// Enterprise Type
const sysType = 'enterprise_type'
export const getType = () => localStorage.getItem(sysType)
export const setType = (type: string) => localStorage.setItem(sysType, type)
export const removeType = () => localStorage.removeItem(sysType)

// Site name
const siteName = 'site_name'
export const getName = () => Cookies.get(siteName)
export const setName = (name: string) => Cookies.set(siteName, name)
export const removeName = () => Cookies.remove(siteName)

// Site logo
const siteLogo = 'site_logo'
export const getLogo = () => Cookies.get(siteLogo)
export const setLogo = (logo: string) => Cookies.set(siteLogo, logo)
export const removeLogo = () => Cookies.remove(siteLogo)

// currency
const siteCurrency = 'currency_key'
export const getCurrency = () => localStorage.getItem(siteCurrency)
export const setCurrency = (currency: string) => localStorage.setItem(siteCurrency, currency)
export const removeCurrency = () => localStorage.removeItem(siteCurrency)

// currency
const siteProduct = 'product_key'
export const getProduct = () => localStorage.getItem(siteProduct)
export const setProduct = (product: string) => localStorage.setItem(siteProduct, product)
export const removeProduct = () => localStorage.removeItem(siteProduct)
